import React from "react";
import { twMerge } from "tailwind-merge";

const STYLE_VARIANTS = {
  default:
    "text-gray-700 dark:text-white hover:bg-tertiary-100 hover:dark:bg-tertiary-900",
  inverted: "text-white hover:bg-tertiary-600 hover:dark:bg-tertiary-900",
};

const SIZE_VARIANTS = {
  lg: "py-3 px-4 gap-2",
  sm: "text-sm p-2 gap-2",
};

interface DropdownMenuItemProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: keyof typeof STYLE_VARIANTS;
  size?: keyof typeof SIZE_VARIANTS;
  className?: string;
  "aria-current"?: React.AriaAttributes["aria-current"];
}
export const DropdownMenuItem = ({
  children,
  onClick = () => {},
  variant = "default",
  size = "lg",
  className,
  "aria-current": ariaCurrent,
}: DropdownMenuItemProps) => {
  return (
    <button
      onClick={onClick}
      aria-current={ariaCurrent}
      className={twMerge(
        "hover:cursor flex items-center p-2 align-middle text-sm font-semibold",
        STYLE_VARIANTS[variant],
        SIZE_VARIANTS[size],
        className
      )}
    >
      {children}
    </button>
  );
};
